import React from "react";
import { useEffect, useState } from "react";
import CustomTable from "components/CustomTable";
import { Button, Col } from "react-bootstrap";
import { Card, CardBody } from "reactstrap";
import { store } from 'app/store'
import { API_URL } from 'app/config'

const EmandiTrading = () => {
  const [users, setUsers] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
 

 
  useEffect(()=>{
    const state = store.getState()
  
    fetch(`${API_URL}/procurement/api/procurement/report`, { headers: { authorization: `Bearer ${state.auth.accessToken}` } })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(data => {
      // Handle the data returned from the API
      if (data != undefined) {
        setUsers(data?.data)
      }
    })
    .catch(error => {
      console.error('There was a problem with the fetch operation:', error);
    });
  },[])
  

  const columns = [

    { field: "Date", headerName: "Date", width: 140, cellClassName: 'custom-cell'  },
    { field: "Bill Value", headerName: "Bill Value", width: 150 },
    { field: "Party Name", headerName: "Party Name ", width: 200 },
    { field: "Location", headerName: "Location", width: 130 },
    { field: "Item", headerName: "Item", width: 150 },
    { field: "Qty in Qtl", headerName: "Qty in Qtl", width: 140 },
    { field: "Rate per Qtl", headerName: "Rate per Qtl", width: 130 },
    { field: "Rate per Kg", headerName: "Rate per Kg", width: 120 },
    { field: "Other charge", headerName: "Other charge", modal_price: 150 },
  ];
  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    checkboxShowFalse:true

  };

  

  return (
    <>
   <div className="mt-3">
   <Card >
   <CardBody  className="p-1">
    <CustomTable
     rows={tableData.rows}
     columns={tableData.columns}
     paginationState={tableData.paginationState}
     loading={tableData.isLoading}
     checkboxShowFalse={tableData.checkboxShowFalse}
   />
   </CardBody>
 </Card>   
   </div>
      </>
  );
};

export default EmandiTrading;
